var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategorySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2167_2154",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2167_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.29175 18.3335V11.7054H8.91994V18.3335H2.29175ZM3.66675 16.9585H7.54494V13.0804H3.66675V16.9585ZM5.78219 8.70854L10.1893 1.48108L14.5962 8.70854H5.78219ZM8.20769 7.33354H12.1707L10.1893 4.14629L8.20769 7.33354ZM19.7948 20.5264L17.3833 18.1149C17.08 18.3346 16.7471 18.5024 16.3846 18.6182C16.022 18.734 15.6375 18.7919 15.231 18.7919C14.1791 18.7919 13.2874 18.426 12.5559 17.6944C11.8242 16.9629 11.4584 16.0712 11.4584 15.0193C11.4584 13.9676 11.8242 13.0759 12.5559 12.3443C13.2874 11.6128 14.1791 11.247 15.231 11.247C16.2827 11.247 17.1744 11.6128 17.906 12.3443C18.6375 13.0759 19.0033 13.9676 19.0033 15.0193C19.0033 15.4166 18.9454 15.795 18.8296 16.1546C18.7139 16.5143 18.5538 16.8457 18.3492 17.149L20.7607 19.5605L19.7948 20.5264ZM15.2305 17.4169C15.9018 17.4169 16.4693 17.1851 16.933 16.7216C17.3965 16.2582 17.6283 15.6909 17.6283 15.0198C17.6283 14.3485 17.3966 13.781 16.9332 13.3173C16.4697 12.8538 15.9023 12.622 15.2312 12.622C14.5599 12.622 13.9925 12.8537 13.5289 13.3171C13.0653 13.7806 12.8334 14.3479 12.8334 15.0191C12.8334 15.6904 13.0652 16.2578 13.5287 16.7214C13.9921 17.185 14.5593 17.4169 15.2305 17.4169Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySearch);
export default __webpack_public_path__ + "static/media/category_search.a0ba57a735dbc6a3305a26791757401a.svg";
export { ForwardRef as ReactComponent };